import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TInputAppState } from '../reducer';
import { TInitStoreLockResult, TInitStoreLockedBy } from '@monorepo/types';
import { Observable, Subject } from 'rxjs';
import { map, take } from 'rxjs/operators';
import produce from 'immer';
import { AcquireLockAndThenUpdateNextCacheResetTimestampDB, UpdateInitStoreLockDetails } from './init-db.actions';
import { getLockDetails, getNextCacheResetTimestamp } from './init-db.query';
import { getConfigurations } from '../app-master-db/app-master.query';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class InitStoreFacade {
  private initCompleted = new Subject<TInitStoreLockedBy>();
  constructor(private store: Store<TInputAppState>, private translate: TranslateService) {}

  initFinished(initBy: TInitStoreLockedBy) {
    this.initCompleted.next(initBy);
  }

  getNextCacheResetTimestamp() {
    return this.store.pipe(select(getNextCacheResetTimestamp));
  }

  getInitCompletionStatusSubscription() {
    return this.initCompleted.asObservable();
  }

  acquireLockAndThenUpdateNextCacheResetTimestamp(lockFor: TInitStoreLockedBy) {
    return this.store.dispatch(new AcquireLockAndThenUpdateNextCacheResetTimestampDB(lockFor));
  }

  getConfigurations() {
    return this.store.pipe(select(getConfigurations));
  }

  getLockDetails() {
    return this.store.pipe(select(getLockDetails));
  }

  acquireLock(lockFor: TInitStoreLockedBy): Observable<TInitStoreLockResult> {
    return this.getLockDetails().pipe(
      take(1),
      map((lockDetails) => {
        if (lockDetails.isLocked) {
          return {
            status: 'FAILURE',
            lockedBy: lockDetails.lockedBy,
            message: `${this.translate.instant('input_app_image_db_effects.please_wait')} (${lockDetails.lockedBy})`,
          };
        } else {
          this.store.dispatch(
            new UpdateInitStoreLockDetails(
              produce(lockDetails, (draft) => {
                draft.isLocked = true;
                draft.lockedBy = lockFor;
              }),
            ),
          );
          return {
            status: 'SUCCESS',
            lockedBy: lockFor,
          };
        }
      }),
    );
  }
}
